<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="dialogShow"
    class="items-no-padding personal-edit sidebar-dialog">
    <div class="sidebar-content h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
          <div class="text-box">
            <div class="text-box-line line-flex-row">
              <div class="text-left">{{$t('User.name')}}</div>
              <div class="line-el"></div>
              <div class="data-right">{{allData.firstName}}{{allData.middlName}}{{allData.lastName}} ({{allData.id}})</div>
            </div>
            <div class="text-box-line line-flex-row">
              <div class="text-left">{{$t('User.gender')}}</div>
              <div class="line-el"></div>
              <div class="data-right">{{getGender}}</div>
            </div>
            <div class="text-box-line line-flex-row">
              <div class="text-left">{{$t('User.nationality')}}</div>
              <div class="line-el"></div>
              <div class="data-right">{{parseCountry}}</div>
            </div>
            <div class="text-box-line line-flex-row">
              <div class="text-left">{{$t('User.certId')}}</div>
              <div class="line-el"></div>
              <div class="data-right">{{ allData.certId }}</div>
            </div>
            <div class="text-box-line line-flex-row">
              <div class="text-left">{{$t('User.birthday')}}</div>
              <div class="line-el"></div>
              <div class="data-right">{{allData.birthday}}</div>
            </div>
          </div>
          <el-form
            class="elform"
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
          >

            <el-row
              :gutter="30"
            >
              <el-col
                v-if="!idImgEditDisabled"
                :span="24">
                <div class="self-label">
                  <b class="self-start">*</b>
                  {{firstLabel}}
                </div>
                <upload-img-tips></upload-img-tips>
              </el-col>
              <el-col
                v-if="!idImgEditDisabled"
                :span="9">
                <el-form-item
                  v-if="!idImgEditDisabled"
                  prop="firstImgUrl"
                >
                  <MobileImageUpload
                    :value="form.firstImgUrl"
                    :disabled="idImgEditDisabled"
                    @input="(url) => { form.firstImgUrl = url }"
                    @success="(url) => { form.firstImgUrl = url }"
                  >
                    <img
                      v-if="form.firstImgUrl"
                      :src="form.firstImgUrl"
                      class="avatar middle"
                      :class="{'not-edit': idImgEditDisabled == true}"
                    >
                    <div v-else class="avatar-uploader-btn">
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                  </MobileImageUpload>
                </el-form-item>
              </el-col>
              <el-col
                v-if="secondColFlag"
                :span="9"
              >
                <el-form-item
                  v-if="!idImgEditDisabled"
                  prop="secondImgUrl"
                >
                  <MobileImageUpload
                    :value="form.secondImgUrl"
                    :disabled="idImgEditDisabled"
                    @input="(url) => { form.secondImgUrl = url }"
                    @success="(url) => { form.secondImgUrl = url }"
                  >
                    <img
                      v-if="form.secondImgUrl"
                      :src="form.secondImgUrl"
                      class="avatar middle"
                      :class="{'not-edit': idImgEditDisabled == true}"
                    >
                    <div v-else class="avatar-uploader-btn">
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                  </MobileImageUpload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
              v-if="!handleImgEditDisabled"
              :label="$t('Holding_ID_photo')"
              prop="handerImgUrl"
            >
              <upload-img-tips></upload-img-tips>
              <MobileImageUpload
                :value="form.handerImgUrl"
                :disabled="handleImgEditDisabled"
                @input="(url) => { form.handerImgUrl = url }"
                @success="(url) => { form.handerImgUrl = url }"
              >
                <img
                  v-if="form.handerImgUrl"
                  :src="form.handerImgUrl"
                  class="avatar middle"
                  :class="{'not-edit': handleImgEditDisabled == true}"
                >
                <div v-else class="avatar-uploader-btn">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </MobileImageUpload>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="submitHandle"
        color="primary"
        :disabled="submitLoading"
      >
        <span v-if="submitLoading"><i class="el-icon-loading"></i> </span>
        {{$t('Confirm')}}
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
// 需要重新联调 确认需求
import { limitImageSizeFormat } from "@/utils/common";
import { commitIdentifyImg } from '@/api/user.js'

import { mapGetters } from 'vuex'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: "personalEditDialog",
  components:{
    VuePerfectScrollbar
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    allData:{
      type: Object,
      default(){
        return {}
      }
    },
    getGender:{
    },
    parseCountry:{
    },
    cardTypeList: {
      type: Array,
      default(){
        return [];
      }
    }
  },
  data() {
    let _this = this;
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: _this.$t('User.userInfo'),

      form: {
        firstImgUrl: '',
        secondImgUrl: '',
        handerImgUrl: '',
      },
      rules: {
        firstImgUrl: [
          { required: true, message: _this.$t('Please_upload'),trigger: 'change' },
        ],
        secondImgUrl: [
          { required: true, message: _this.$t('Please_upload'),trigger: 'change' },
        ],
        handerImgUrl: [
          { required: true, message: _this.$t('Please_upload'),trigger: 'change' },
        ],
      },

      frontLoading: false,
      backLoading: false,
      handleCertLoading: false,
      submitLoading: false,
    }
  },

  watch: {
    allData:{
      handler(val){
        this.form.firstImgUrl = val.certValidatedImgFrontUrl;
        this.form.secondImgUrl = val.certValidatedImgBackUrl;
        if(val.handleCertImgUrl){
          this.form.handerImgUrl = val.handleCertImgUrl;
        }
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
    handleImgEditDisabled(){
      //手持身份证验证通过
      return this.allData.handleCertIdentifyStatus == 3;
    },
    idImgEditDisabled(){
      //身份证验证通过
      return this.allData.identifyStatus == 3;
    },
    idTypeText(){
      let lastText = '';
      if(!this.cardTypeList.length){
        lastText = '';
      }else {
        for (let i = 0; i <this.cardTypeList.length; i++) {
          if(this.allData.certType == this.cardTypeList[i].value){
            lastText = this.cardTypeList[i].label;
            break;
          }
        }
      }
      return lastText;
    },
    firstLabel(){
      // 根据身份证类型判断
      return `${this.idTypeText}${this.$t('photo')}`;
    },
    secondColFlag(){
      // 选择了有两张照片类型的才有.
      if(this.allData.certType == '1' || this.allData.certType == '4' || this.allData.certType == '5'){
        return true;
      }else {
        return false;
      }
    }
  },
  methods: {
    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    submitHandle(){
      if (this.submitLoading) return;
      this.$refs.form.validate((valid) => {
        if(valid){
          let params = {
          };
          if(!this.idImgEditDisabled){
            params.certValidatedImgFront = this.form.firstImgUrl;
            if(this.secondColFlag){
              params.certValidatedImgBack = this.form.secondImgUrl;
            }
          }
          if(!this.handleImgEditDisabled){
            params.handleCertImg = this.form.handerImgUrl;
          }
          this.submitLoading = true;
          commitIdentifyImg(params).then((res) => {
            this.$message({
              message: this.$t('User.authSubmitSuccess'),
              type: 'success'
            });
            this.$emit('ajax-success');
          }).finally(() => {
            this.submitLoading = false;
          });
        }else {
          console.log('error');
        }
      })
    },
    cancelHandle(){
      this.close();
    },
    // 上传图片的限制
    beforeAvatarUpload(file){
      return limitImageSizeFormat(file,this);
    },
    uploadfrontHandle(item){
      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);

        this.frontLoading = true;
        this.$uploadFile(file).then((res) => {
          this.frontLoading = false;
          this.form.firstImgUrl = res.data.data.content[0].url;
        }).catch((err) => {
          this.frontLoading = false;
        })
      });

    },
    uploadSecondHandle(item){

      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);
        this.backLoading = true;
        this.$uploadFile(file).then((res) => {
          this.backLoading = false;
          this.form.secondImgUrl = res.data.data.content[0].url;
        }).catch((err) => {
          this.backLoading = false;
        })
      });

    },
    // 上传手持证件照
    uploadHandletHandle(item){
      this.$getBase64(item.file).then(res => {
        let file = this.$base64toFile(res);
        this.handleCertLoading = true;
        this.$uploadFile(file).then((res) => {
          this.handleCertLoading = false;
          this.form.handerImgUrl = res.data.data.content[0].url;
        }).catch((err) => {
          this.handleCertLoading = false;
        })
      });

    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.personal-edit {
  .content {
    padding-top: 30px;
    .text-box {
      background-color: #F8F8F8;
      padding: 10px;
      border-radius: 6px;
      .text-box-line {
        margin-bottom: 10px;
        font-size: 14px;
        .text-left {
          color: #A29FAE;
        }
        .data-right {
          color: #6E6B7B;
        }
      }
    }
    .avatar {
      width: 120px;
      height: 70px;
    }
    .avatar-uploader-btn {
      width: 120px;
      height: 70px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: 2px dashed #D8D6DE;
    }
    .elform {
      margin-top: 30px;
    }
    .self-start {
      color: #F56C6C;
      font-size: 14px;
    }
  }
}
</style>
<style lang="scss">
.personal-edit {
  .vs-sidebar--items {

  }
  .avatar-uploader {
    display: inline-block;


  }
  .not-edit {
    position: relative;
    z-index: 99;
    cursor: not-allowed;
  }
  .scroll-area--customizer {
    height: calc(100% - 5rem);
  }
  .vs-sidebar {
    position: fixed;
    z-index: 999;
    .sidebar-content {
    }
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
